.root {
  opacity: 0.55;
}

.hasError {
  color: var(--sentiment-negative);
  opacity: 1;
}
